export class DatePickerRestrictionsManager {
  constructor(
    datePickerController,
    getSlots,
    onTimeZoneChange,
    toLuxonDateTimeKeepingSameTime
  ) {
    this.datePickerController = datePickerController
    this.getSlots = getSlots
    this.toLuxonDateTimeKeepingSameTime = toLuxonDateTimeKeepingSameTime

    // When the date picker view date changes, let's update the restrictions
    this.datePickerController.onViewDateChanged((date) =>
      this.updateRestrictions(date)
    )

    // When the timeZone changes, let's update the restrictions
    onTimeZoneChange(() => {
      this.updateRestrictions(this.datePickerController.getViewDate())
    })

    // Let's update the restrictions on initial load
    this.updateRestrictions(this.datePickerController.getViewDate())
  }

  updateRestrictions = async (dateTimePickerDate) => {
    const luxon = this.toLuxonDateTimeKeepingSameTime(dateTimePickerDate)
    const luxons = [luxon]
    // Only the newest request may set the enabled dates (another month, length or time zone).
    const refresh = (this.refresh = (this.refresh || 0) + 1)

    const slots = await Promise.all(
      luxons.map((luxon) => {
        const start = luxon.startOf('month')
        const end = luxon.endOf('month')
        return this.getSlots(start, end)
      })
    )
    if (refresh !== this.refresh) return

    const enabledDates = slots
      .flat()
      .map((slot) => slot.start.toFormat('yyyy-M-d'))
    this.datePickerController.setEnabledDates(enabledDates)
  }
}
